import React from 'react';
import sadadLogo from './assets/payment-methods/sadad-logo.png';
import lypayLogo from './assets/payment-methods/lypay-logo.png';
import getcustomerLogo from './assets/payment-methods/getcustomer-logo.png';

const PaymentMethodsSection = ({ isArabic }) => {
  return (
    <section className="payment-methods-section">
      <div className="container">
        <h2 className="section-title">
          {isArabic ? 'وسائل الدفع' : 'Payment Methods'}
        </h2>
        <div className="payment-logos-container">
          <div className="payment-logos-track">
            <img src={sadadLogo} alt="Sadad" className="payment-logo" />
            <img src={lypayLogo} alt="LyPay" className="payment-logo" />
            <img src={getcustomerLogo} alt="GetCustomer" className="payment-logo" />
            <img src={sadadLogo} alt="Sadad" className="payment-logo" />
            <img src={lypayLogo} alt="LyPay" className="payment-logo" />
            <img src={getcustomerLogo} alt="GetCustomer" className="payment-logo" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentMethodsSection;